import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/views/index'
import moreCity from '@/views/moreCity'
import $store from '@/vuex/store'
import {queryUserDetl} from "../config/axioUtil";

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '*',
    redirect: {path: '/index'}
  },
  {
    path: '',
    name: '',
    redirect: {path: '/index'},
    component: ()=>import('../views/app.vue'),
    children: [
      {
        path: 'index',
        name: 'index',
        components: {
          head: ()=>import('../components/header.vue'),
          content: ()=>import('../views/index.vue'),
          footer: ()=>import('../components/footer.vue'),
        }
      },
      {
        path: 'moreCity',
        name: 'moreCity',
        components: {
          content: ()=>import('../views/moreCity.vue'),

        },
      },
      {
        path: 'login',
        name: 'login',
        components: {
          head: ()=>import('../components/headerTwo'),
          content: ()=>import('../views/loginOrOut/login'),
          footer: ()=>import('../components/footer')
        }
      },
      {
        path: 'register',
        name: 'register',
        components: {
          head: ()=>import('../components/headerTwo'),
          content: ()=>import('../views/loginOrOut/register'),
          footer: ()=>import('../components/footer')
        }
      },
      {
        path: 'forget',
        name: 'forget',
        components: {
          head: ()=>import('../components/headerTwo'),
          content: ()=>import('../views/loginOrOut/forget'),
          footer: ()=>import('../components/footer')
        }
      },
      {
        path: 'faculty',
        name: 'faculty',
        components: {
          head: ()=>import('../components/header'),
          content: ()=>import('../views/faculty/faculty'),
          footer: ()=>import('../components/footer')
        },
        children: [
          {
            path: 'list',
            name: 'faculty-list',
            component: ()=>import('../views/faculty/facultyList')
          },
          {
            path: 'teacher/:teacherID',
            name: 'teacher',
            component: ()=>import('../views/faculty/facultyDetail')
          },

        ]
      },
      {
        path: 'students',
        name: 'students',
        components: {
          head: ()=>import('../components/header'),
          content: ()=>import('../views/student/students'),
          footer: ()=>import('../components/footer')
        },
        children: [
          {
            path: 'list',
            name: 'students-list',
            component: ()=>import('../views/student/studentsList')
          },
          {
            path: 'detail/:detailID',
            name: 'students-detail',
            component: ()=>import('../views/student/studentDetail')
          },

        ]
      },
      {
        path: 'alternative',
        name: 'alternative',
        components: {
          head: ()=>import('../components/header'),
          content: ()=>import('../views/order/alternative'),
          footer: ()=>import('../components/footer')
        },
      },
      {
        path: 'tutor',
        name: 'tutor',
        components: {
          head: ()=>import('../components/header'),
          content: ()=>import('../views/order/tutor'),
          footer: ()=>import('../components/footer')
        },
      },
      {
        path: 'tutorInfo/:tutorID',
        name: 'tutorInfo',
        components: {
          head: ()=>import('../components/header'),
          content: ()=>import('../views/order/tutorInfo'),
          footer: ()=>import('../components/footer')
        },
      },
      {
        path: 'pay',
        name: 'pay',
        components: {
          // head: ()=>import('../components/header'),
          content: ()=>import('../views/order/payPage'),
          // footer: ()=>import('../components/footer')
        },
      },
      {
        path: 'success',
        name: 'success',
        components: {
          // head: ()=>import('../components/header'),
          content: ()=>import('../views/order/tishi'),
          // footer: ()=>import('../components/footer')
        },
      },
      {
        path: 'member',
        name: 'member',
        components: {
          content: ()=>import('../views/personal/member'),
        },
        children: [
          {
            path: 'faculty',
            name: 'faculty-member',
            component: ()=>import('../views/personal/facultyMember'),
            children: [
              {
                path: 'editorInfo',
                name: 'faculty-editorInfo',
                component: ()=>import('../views/personal/editorInfo')
              },
              {
                path: 'facultyInfo',
                name: 'faculty-facultyInfo',
                component: ()=>import('../views/personal/facultyInfo')
              },
              {
                path: 'certification',
                name: 'faculty-certification',
                component: ()=>import('../views/personal/certification')
              },
              {
                path: 'payment',
                name: 'faculty-payment',
                component: ()=>import('../views/personal/payment')
              },
              {
                path: 'apply',
                name: 'faculty-apply',
                component: ()=>import('../views/personal/apply')
              },
              {
                path: 'success',
                name: 'faculty-success',
                component: ()=>import('../views/personal/success')
              },
              {
                path: 'refund',
                name: 'faculty-refund',
                component: ()=>import('../views/personal/refund')
              },
              {
                path: 'complain',
                name: 'faculty-complain',
                component: ()=>import('../views/personal/complaints')
              },
              {
                path: 'resetting',
                name: 'faculty-resetting',
                component: ()=>import('../views/personal/reset')
              },
              {
                path: 'system',
                name: 'faculty-system',
                component: ()=>import('../views/personal/system')
              },
            ]
          },
          {
            name: 'student-member',
            path: 'student',
            component: ()=>import('../views/personal/student/studentMember'),
            children: [
              {
                path: 'order',
                name: 'student-order',
                component: ()=>import('../views/personal/student/userOrder')
              },
              {
                path: 'apply',
                name: 'student-apply',
                component: ()=>import('../views/personal/student/userApply')
              },
              {
                path: 'success',
                name: 'student-success',
                component: ()=>import('../views/personal/student/userSuccess')
              },
              {
                path: 'collect',
                name: 'student-collect',
                component: ()=>import('../views/personal/student/mycollect')
              },
              {
                path: 'orderform',
                name: 'student-orderform',
                component: ()=>import('../views/personal/student/orderform')
              },
              {
                path: 'testreport',
                name: 'student-testreport',
                component: ()=>import('../views/personal/student/testreport')
              },
              {
                path: 'solomonresult',
                name: 'student-solomonresult',
                // components: {
                  // head: () => import('../components/header'),
                  // content: () => import('../views/solomonresult/solomonresult.vue'),
                  // footer: () => import('../components/footer')
                // },
                component: ()=>import('../views/solomonresult/solomonresult.vue'),
                meta: {
                  title: '所罗门测试报告',
                },
                children: [
                  {
                    path: 'solomonViewone',
                    name: 'student-solomonViewone',
                    component: () => import('../views/solomonresult/solomonViewone.vue'),
                    meta: {
                      title: '测试报告1',
                    }
                  },
                  {
                    path: 'solomonViewtwo',
                    name: 'student-solomonViewtwo',
                    component: () => import('../views/solomonresult/solomonViewtwo.vue'),
                    meta: {
                      title: '测试报告2',
                    }
                  },
                  {
                    path: 'solomonViewthree',
                    name: 'student-solomonViewthree',
                    component: () => import('../views/solomonresult/solomonViewthree.vue'),
                    meta: {
                      title: '测试报告3',
                    }
                  },
                ]
              },
            ]
          }
        ],
      },
      {
        path: 'news',
        name: 'news',
        components: {
          head: ()=>import('../components/header'),
          content: ()=>import('../views/news/news'),
          footer: ()=>import('../components/footer')
        },
        children: [
          {
            path: 'list',
            name: 'news-list',
            component: ()=>import('../views/news/newsList')
          },
          {
            path: 'detail/:newID',
            name: 'news-detail',
            component: ()=>import('../views/news/newsDetail')
          }
        ]
      },
      {
        path: 'help',
        name: 'help',
        components: {
          head: ()=>import('../components/header'),
          content: ()=>import('../views/documents/help.vue'),
          footer: ()=>import('../components/footer')
        },
        children: [
          {
            path: 'agreement',
            name: 'agreement',
            component: () => import('../views/documents/agreement'),
          },
          {
            path: 'price',
            name: 'price',
            component: () => import('../views/documents/price')
          },
          {
            path: 'process',
            name: 'process',
            component: () => import('../views/documents/process')
          },
          {
            path: 'appointment',
            name: 'appointment',
            component: () => import('../views/documents/appointment')
          },
          {
            path: 'standard',
            name: 'standard',
            component: () => import('../views/documents/standard')
          },
          {
            path: 'payment',
            name: 'payment',
            component: () => import('../views/documents/payment')
          },
          {
            path: 'relief',
            name: 'relief',
            component: () => import('../views/documents/relief')
          },
          {
            path: 'privacy',
            name: 'privacy',
            component: () => import('../views/documents/privacy')
          },
          {
            path: 'profile',
            name: 'profile',
            component: () => import('../views/documents/profile')
          },
          {
            path: 'contact',
            name: 'contact',
            component: () => import('../views/documents/contact')
          },
          {
            path: 'advertises',
            name: 'advertises',
            component: () => import('../views/documents/advertises')
          },
        ]
      },
      {
        path: 'buyvip',
        name: 'buyvip',
        components: {
          head: ()=>import('../components/header'),
          content: ()=>import('../views/buyvip'),
          footer: ()=>import('../components/footer')
        },
        meta: {
          title: '充值',
        }
      },
      {
        path: 'univs',
        name: 'univs',
        components: {
          head: () => import('../components/header'),
          content: () => import('../views/univs/univs-listall'),
          footer: () => import('../components/footer')
        },
        children: [
          {
            path: 'univscin',
            name: 'univscin',
            component: () => import('../views/univs/univs-listcin.vue'),
            meta: {
              title: '国内',

            }
          },
          {
            path: 'univsabroad',
            name: 'univsabroad',
            component: () => import('../views/univs/univs-listabroad.vue'),
            meta: {
              title: '国外',
            }
          },

          {
            path: 'univsmain/:whichunivs',
            name: 'univsmain',
            component: () => import('../views/univs/univs-main.vue'),
            meta: {
              title: '学校详情',
            }
          },
          {
            path: 'univsnew/:whichunivs/:whichunivsId',
            name: 'univsnew',
            component: () => import('../views/news/univsnew.vue'),
            meta: {
              title: '大学咨询',
            }
          },
          {
            path: 'collegemain/:whichunivs/:whichcollege',
            name: 'collegemain',
            component: () => import('../views/univs/college-main.vue'),
            meta: {
              title: '学院详情',
            }
          },
          {
            path: 'subjectmain/:whichindustry',
            name: 'subjectmain',
            component: () => import('../views/univs/subject-main.vue'),
            meta: {
              title: '专业详情',
            }
          },
          {
            path: 'univsmainaborad/:univsaboradId',
            name: 'univsmainaborad',
            component: () => import('../views/univs/univs-mainaborad.vue'),
            meta: {
              title: '学校详情国外',
              need_log: false,
              showServer: true
            }
          },
        ]
      },
      {
        path: 'contrast',
        name: 'contrast',
        components: {
          head: () => import('../components/header'),
          content: () => import('../views/contrast/new-contrast.vue'),
          footer: () => import('../components/footer')
        },
        meta: {
          title: '学校对比',
        },
        children: [
          {
            path: 'univsContrast',
            name: 'univsContrast',
            component: () => import('../views/contrast/univsContrast.vue'),
            meta: {
              title: '大学对比',
            }
          },
          {
            path: 'subjectContrast',
            name: 'subjectContrast',
            component: () => import('../views/contrast/subjectContrast.vue'),
            meta: {
              title: '专业对比',
            }
          }
        ]
      },
      {
        path: 'industry',
        name: 'industry',
        components: {
          head: () => import('../components/header'),
          content: () => import('../views/industry/industry.vue'),
          footer: () => import('../components/footer')
        },
        meta: {
          title: '职业库',
        }
      },
      {
        path: 'test',
        name: 'test',
        components: {
          head: () => import('../components/header'),
          content: () => import('../views/testModel/testModel.vue'),
          footer: () => import('../components/footer')
        },
        children: [
          {
            path: 'solomon',
            name: 'solomon',
            component: () => import('../views/testModel/solomonTest.vue'),
            meta: {
              title: '所罗门评测',
            }
          },
          {
            path: 'solomonGoTest',
            name: 'solomonGoTest',
            component: () => import('../views/testModel/solomonGoTest.vue'),
            meta: {
              title: '所罗门评测页面',
            }
          },

          {
            path: 'freeTest/:crowds',
            name: 'freeTest',
            component: () => import('../views/testModel/freeTest.vue'),
            meta: {
              title: '免费评测',
            }
          },
          {
            path: 'tollTest',
            name: 'tollTest',
            component: () => import('../views/testModel/tollTest.vue'),
            meta: {
              title: '收费测试列表',
            }
          },
          {
            path: 'oneToone',
            name: 'oneToone',
            component: () => import('../views/testModel/oneToone.vue'),
            meta: {
              title: '一对一',
            }
          },
          {
            path: 'tollGoTest',
            name: 'tollGoTest',
            component: () => import('../views/testModel/tollGoTest.vue'),
            meta: {
              title: '收费测试',
            }
          },
          {
            path: 'gangweituijian',
            name: 'gangweituijian',
            component: () => import('../views/testModel/gangweituijian.vue'),
            meta: {
              title: '实习/职业岗位推荐',
            }
          },
        ]
      },
      {
        path: 'dispose/:orderID',
        name: 'dispose',
        components: {
          // head: () => import('../components/header'),
          content: () => import('../views/order/dispose'),
          // footer: () => import('../components/footer')
        },
      },
    ]
  }
]
const router = new Router({
  routes,
  mode: 'history',
  // base: '/miucas/',

})

export default router

// export default new Router({
//   mode: 'history',
//   routes: [
//     {
//       path: '*',
//       redirect: {path: '/index'}
//     },
//     {
//       path: '',
//       name: '',
//       redirect: {path: '/index'},
//       component: ()=>import('../views/app.vue'),
//       children: [
//         {
//           path: 'index',
//           name: 'index',
//           components: {
//             head: ()=>import('../components/header.vue'),
//             content: ()=>import('../views/index.vue'),
//             footer: ()=>import('../components/footer.vue'),
//           }
//         },
//         {
//           path: 'moreCity',
//           name: 'moreCity',
//           components: {
//             content: ()=>import('../views/moreCity.vue'),
//
//           },
//         }
//       ]
//     },
//
//
//
//   ]
// })



// WEBPACK FOOTER //
// ./src/router/index.js